import { red } from '@mui/material/colors';
export const error_colors = (dark) => ({
    '50': '#FFF0F1',
    '100': '#FFDBDE',
    '200': '#FFBDC2',
    '300': '#FF99A2',
    '400': '#FF7A86',
    '500': '#FF505F',
    '600': '#EB0014',
    '700': '#C70011',
    '800': '#94000D',
    '900': '#570007',
    main: dark ? red[300] : red[700], // "main": "#EB0014",
    light: dark ? '#e57373' : '#FF99A2',
    dark: dark ? '#d32f2f' : '#C70011',
    contrastText: '#fff',
});
